import UserIcon from "components/Icons/UserIcon";
import { Button, Spin } from "antd";
import LabeledDateInput from "components/Form/LabeledDateInput";
import LabeledInput from "components/Form/LabeledInput";
import LabeledSelectInput from "components/Form/LabeledSelectInput";
import useEditDriver from "hooks/drivers/useEditDriver";
import LabeledUploadInput from "components/Form/LabeledUploadInput";
import LabeledUploadsInput from "components/Form/LabeledUploadsInput";

export default function EditDriver() {
  const {
    loading: { button, page },
    cities,
    control,
    handleSubmit,
    onSubmit,
    handleUploadDriverImage,
    handleUploadDriverLicenseImage,
    handleUploadInsuranceSubscriptionImage,
    handleUploadEmploymentAgreementImage,
    handleUploadMaheberSupportImage,
    handleUploadDriverIdImage,
    handleUploadOwnerIdImage,
    handleUploadBoloImage,
    handleUploadBusinessLicenseImage,
    handleUploadOtherImages,
  } = useEditDriver();

  return (
    <div
      className="w-full bg-white rounded-lg p-6"
      style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
    >
      <div className="w-full pt-5 pb-5">
        <div className="w-full">
          <h1 className="p-5 font-light text-lg text-center">Edit Driver</h1>

          <div className="w-full">
            <div className="w-full relative h-1 top-7 overflow-clip rounded-md">
              <div className="w-1/2 bg-black h-full rounded-md"></div>
            </div>
            <div className="relative w-full flex justify-center">
              <div className="relative h-14 w-14 bg-black rounded-full flex items-center justify-center text-white text-2xl">
                <UserIcon />
              </div>
            </div>
          </div>
          <p className="text-center mt-2 text-sm font-normal">
            Driver Information
          </p>
        </div>
        <div className="w-full py-8 px-5">
          {page ? (
            <div className="w-full flex items-center justify-center py-20">
              <Spin />
            </div>
          ) : (
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="w-full flex flex-wrap"
            >
              <div className="w-full px-4 pt-5 md:w-1/3">
                <LabeledInput
                  label="Driver First Name"
                  type="text"
                  control={control}
                  name="first_name"
                  placeholder="Driver First Name"
                />
              </div>
              <div className="w-full px-4 pt-5 md:w-1/3">
                <LabeledInput
                  label="Driver Middle Name"
                  type="text"
                  control={control}
                  name="middle_name"
                  placeholder="Driver Middle Name"
                />
              </div>
              <div className="w-full px-4 pt-5 md:w-1/3">
                <LabeledInput
                  label="Driver Last Name"
                  type="text"
                  control={control}
                  name="last_name"
                  placeholder="Driver Last Name"
                />
              </div>
              <div className="w-full px-4 pt-5 md:w-1/3">
                <LabeledInput
                  label="Driver Full Name (Local)"
                  type="text"
                  control={control}
                  name="local_full_name"
                  placeholder="Driver Full Name (Local)"
                />
              </div>
              <div className="w-full px-4 pt-5 md:w-1/3">
                <LabeledInput
                  label="Driver Phone Number"
                  type="tel"
                  control={control}
                  name="phone"
                  placeholder="Driver Phone Number"
                />
              </div>
              <div className="w-full px-4 pt-5 md:w-1/3">
                <LabeledInput
                  label="Driver Backup Phone Number"
                  type="tel"
                  control={control}
                  name="backup_phone"
                  placeholder="Driver Backup Phone Number"
                />
              </div>
              <div className="w-full px-4 pt-5 md:w-1/3">
                <LabeledInput
                  label="Driver Email (Optional)"
                  type="email"
                  control={control}
                  name="email"
                  placeholder="Driver Email"
                />
              </div>
              <div className="w-full px-4 pt-5 md:w-1/3">
                <LabeledSelectInput
                  label="City"
                  control={control}
                  loading={cities.loading}
                  name="city_id"
                  placeholder="Select City"
                  options={cities.data.map((value) => ({
                    value: value.id,
                    label: value.name,
                  }))}
                />
              </div>
              <div className="w-full px-4 pt-5 md:w-1/3">
                <LabeledSelectInput
                  label="Gender"
                  control={control}
                  name="gender"
                  placeholder="Select Gender"
                  options={[
                    { label: "Male", value: "male" },
                    { label: "Female", value: "female" },
                  ]}
                />
              </div>
              <div className="w-full px-4 pt-5 md:w-1/3">
                <LabeledInput
                  label="Driver Tin Number"
                  type="text"
                  control={control}
                  name="tin_number"
                  placeholder="Driver Tin Number"
                />
              </div>
              <div className="w-full px-4 pt-5 md:w-1/3">
                <LabeledDateInput
                  label="Driver Date of Birth"
                  control={control}
                  name="date_of_birth"
                  placeholder="Driver Date of Birth"
                />
              </div>
              <div className="w-full px-4 pt-5 md:w-1/3"></div>
              <div className="w-full px-4 pt-5 md:w-1/3">
                <LabeledUploadInput
                  control={control}
                  name="image"
                  placeholder="Select Driver Image"
                  label="Driver Image"
                  action={handleUploadDriverImage}
                />
              </div>
              <div className="w-full px-4 pt-5 md:w-1/3">
                <LabeledUploadInput
                  control={control}
                  name="driving_license_image"
                  placeholder="Select Driver License Image"
                  label="Driver License Image"
                  action={handleUploadDriverLicenseImage}
                />
              </div>
              <div className="w-full px-4 pt-5 md:w-1/3">
                <LabeledUploadInput
                  control={control}
                  name="insurance_subscription_image"
                  placeholder="Select Driver Insurance image"
                  label="Driver Insurance Image"
                  action={handleUploadInsuranceSubscriptionImage}
                />
              </div>
              <div className="w-full px-4 pt-5 md:w-1/3">
                <LabeledUploadInput
                  control={control}
                  name="employment_agreement_image"
                  placeholder="Select Driver employment agreement image"
                  label="Driver Employment Agreement Image"
                  action={handleUploadEmploymentAgreementImage}
                />
              </div>
              <div className="w-full px-4 pt-5 md:w-1/3">
                <LabeledUploadInput
                  control={control}
                  name="maheber_support_image"
                  placeholder="Select Maheber Support Image"
                  label="Maheber Support Image"
                  action={handleUploadMaheberSupportImage}
                />
              </div>
              <div className="w-full px-4 pt-5 md:w-1/3">
                <LabeledUploadInput
                  control={control}
                  name="driver_id_image"
                  placeholder="Select Driver Id Image"
                  label="Driver Id Image"
                  action={handleUploadDriverIdImage}
                />
              </div>
              <div className="w-full px-4 pt-5 md:w-1/3">
                <LabeledUploadInput
                  control={control}
                  name="owner_id_image"
                  placeholder="Select Owner Id Image"
                  label="Owner Id Image"
                  action={handleUploadOwnerIdImage}
                />
              </div>
              <div className="w-full px-4 pt-5 md:w-1/3">
                <LabeledUploadInput
                  control={control}
                  name="bolo_image"
                  placeholder="Select Bolo Image"
                  label="Bolo Image"
                  action={handleUploadBoloImage}
                />
              </div>
              <div className="w-full px-4 pt-5 md:w-1/2 flex items-center gap-x-4">
                <LabeledUploadsInput
                  control={control}
                  name="business_license_images"
                  placeholder="Select Driver Business License Image"
                  action={handleUploadBusinessLicenseImage}
                  label="Driver Business License Images"
                />
              </div>
              <div className="w-full px-4 pt-5 md:w-1/2 flex items-center gap-x-4">
                <LabeledUploadsInput
                  control={control}
                  name="other_images"
                  placeholder="Select Other Images"
                  action={handleUploadOtherImages}
                  label="Other Images"
                />
              </div>
              <div className="w-full flex mt-8 justify-end">
                <Button
                  htmlType="submit"
                  type="primary"
                  loading={button}
                  className="py-2 px-8 rounded-md float-right h-auto font-medium w-fit shadow-none"
                >
                  Update Driver
                </Button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
